import { useState } from 'react';

import { createContexts } from '@/js/libs/create-contexts';

const { useSearchContext } = createContexts({
  Search() {
    const [searchValue, setSearchValue] = useState<string>('');

    return { searchValue, setSearchValue };
  },
});

export { useSearchContext };
